// // FeaturesQuickActions.jsx
// import React, { useState } from "react";
// import "./flip-cards.mobile.css";

// import ActionModal from "./common/ActionModal";
// import FormGroup from "./common/FormGroup";
// import ModalFooter from "./common/ModalFooter";

// const QuickActionCard = ({ icon, title, desc, target, btnText }) => (
//   <div className="col-12 col-sm-6 col-lg-4">
//     <div className="card h-100 shadow-sm">
//       <div className="card-body">
//         <div className="d-flex align-items-center mb-2">
//           <i className={`bi ${icon} text-primary-label fs-3 me-2`} aria-hidden="true"></i>
//           <h5 className="card-title mb-0">{title}</h5>
//         </div>
//         <p className="card-text text-muted">{desc}</p>
//         <button
//           className="btn btn-outline-teal"
//           data-bs-toggle="modal"
//           data-bs-target={target}
//           type="button"
//           aria-controls={target.replace("#", "")}
//           aria-haspopup="dialog"
//         >
//           {btnText}
//         </button>
//       </div>
//     </div>
//   </div>
// );

// const FeaturesQuickActions = () => {
//   const actions = [
//     { icon: "bi-calendar-plus",     title: "Create Event",        desc: "Plan society events, invite residents, manage RSVPs.", id: "createEventModal",     btnText: "Create",   },
//     { icon: "bi-check2-square",     title: "Conduct Election",    desc: "Set up digital voting, track results securely.",        id: "conductElectionModal", btnText: "Setup"    },
//     { icon: "bi-megaphone",         title: "Publish Notice",      desc: "Announce updates with read receipts & attachments.",   id: "publishNoticeModal",   btnText: "Publish"  },
//     { icon: "bi-pass",              title: "Generate Entry Pass", desc: "Visitor pass with QR verification at gate.",          id: "entryPassModal",       btnText: "Generate" },
//     { icon: "bi-exclamation-octagon", title: "Raise Complaint",   desc: "Ticketing with SLA, comments, and escalations.",      id: "complaintModal",       btnText: "Raise"    },
//     { icon: "bi-shield-shaded",     title: "Security Log",        desc: "Guard shifts, incident logs, and analytics.",         id: "securityLogModal",     btnText: "Log"      },
//   ];

//   // SR-friendly flip state (mobile)
//   const [flipped, setFlipped] = useState(() => actions.map(() => false));
//   const toggleFlip = (i) => setFlipped((prev) => prev.map((f, idx) => (idx === i ? !f : f)));

//   return (
//     <section id="features" className="py-5 bg-light">
//       <div className="container">
//         <div className="text-center mb-4">
//           <h2 className="fw-bold text-primary-label">Do More With Quick Actions</h2>
//           <p className="text-muted">Create events, conduct elections, publish notices—instantly.</p>
//         </div>

//         {/* MOBILE (< md): 2×N flip grid with accessibility */}

// {/* --- MOBILE (< md): compact 2×N flip grid with colors & micro-interactions --- */}
// <div className="d-md-none">
//   <div className="qa-grid-compact" role="list" aria-label="Quick actions">
//     {actions.map((a, i) => {
//       const target = `#${a.id}`;
//       const hintId = `${a.id}-hint`;
//       const liveId = `${a.id}-live`;
//       const titleId = `${a.id}-title`;

//       // assign a color class based on index (see CSS palette below)
//       const colorClass = `qa-${(i % 6) + 1}`;

//       return (
//         <div key={a.id} role="listitem">
//           <span id={hintId} className="visually-hidden">
//             Press Enter or Space to flip and reveal the action details and button.
//           </span>
//           <span id={liveId} className="visually-hidden" aria-live="polite">
//             {flipped[i] ? "Details shown." : "Details hidden."}
//           </span>

//           <button
//             type="button"
//             className={`flip-card qa-flip ${flipped[i] ? "is-flipped" : ""} ${colorClass}`}
//             onClick={() => toggleFlip(i)}
//             onKeyDown={(e) => {
//               if (e.key === "Enter" || e.key === " ") {
//                 e.preventDefault();
//                 toggleFlip(i);
//               }
//             }}
//             aria-expanded={flipped[i]}
//             aria-describedby={`${hintId} ${liveId}`}
//             aria-roledescription="flip card"
//             aria-label={`${a.title}`}
//           >
//             <span className="qa-ripple" aria-hidden="true"></span>

//             <div className="flip-card-inner">
//               {/* FRONT (icon + title + short preview) */}
//               <div className="flip-card-face flip-card-front" aria-hidden={flipped[i]}>
//                 <div className="qa-header">
//                   <div className="qa-badge icon-wrap icon-animated text-primary-label" aria-hidden="true">
//                     <i className={`bi ${a.icon} icon-lg`} />
//                   </div>
//                   <div className="qa-title" id={titleId}>{a.title}</div>
//                 </div>
//                 {/* short preview (two lines max) */}
//                 <p className="qa-preview text-muted" aria-hidden="true">
//                   {a.desc}
//                 </p>
//               </div>

//               {/* BACK (desc + CTA) */}
//               <div className="flip-card-face flip-card-back" aria-hidden={!flipped[i]}>
//                 <div className="qa-title">{a.title}</div>
//                 <p className="qa-desc text-muted">{a.desc}</p>
//                 <button
//                   type="button"
//                   className="btn btn-outline-teal btn-sm w-100"
//                   data-bs-toggle="modal"
//                   data-bs-target={target}
//                   aria-controls={a.id}
//                   aria-haspopup="dialog"
//                   onClick={(e) => e.stopPropagation()}  // keep card flipped while opening modal
//                 >
//                   {a.btnText}
//                 </button>
//                 <span className="hint d-block mt-1">Tap to flip back</span>
//               </div>
//             </div>
//           </button>
//         </div>
//       );
//     })}
//   </div>
// </div>

//         {/* DESKTOP/TABLET (>= md): Original Bootstrap cards */}
//         <div className="row g-4 d-none d-md-flex">
//           {actions.map((a) => (
//             <QuickActionCard
//               key={a.id}
//               icon={a.icon}
//               title={a.title}
//               desc={a.desc}
//               target={`#${a.id}`}
//               btnText={a.btnText}
//             />
//           ))}
//         </div>
//       </div>

//       {/* ---- Shared Modals (unchanged) ---- */}
//       <ActionModal id="createEventModal" title="Create Event">
//         <FormGroup label="Event Title" id="eventTitle" required />
//         <FormGroup label="Date & Time" id="eventDate" type="datetime-local" required />
//         <FormGroup label="Location" id="eventLocation" required />
//         <FormGroup label="Description" id="eventDesc" type="textarea" />
//         <ModalFooter primary="Create Event" />
//       </ActionModal>

//       <ActionModal id="conductElectionModal" title="Conduct Election">
//         <FormGroup label="Election Title" id="electionTitle" required />
//         <FormGroup label="Start Date" id="electionStart" type="date" required />
//         <FormGroup label="End Date" id="electionEnd" type="date" required />
//         <FormGroup label="Positions" id="electionPositions" placeholder="e.g., President, Secretary" />
//         <ModalFooter primary="Start Election" />
//       </ActionModal>

//       <ActionModal id="publishNoticeModal" title="Publish Notice">
//         <FormGroup label="Subject" id="noticeSubject" required />
//         <FormGroup label="Message" id="noticeMessage" type="textarea" required />
//         <FormGroup label="Attachment (optional)" id="noticeFile" type="file" />
//         <ModalFooter primary="Publish Notice" />
//       </ActionModal>

//       <ActionModal id="entryPassModal" title="Generate Entry Pass">
//         <FormGroup label="Visitor Name" id="visitorName" required />
//         <FormGroup label="Resident Flat" id="residentFlat" required />
//         <FormGroup label="Visit Date" id="visitDate" type="date" required />
//         <ModalFooter primary="Generate QR Pass" />
//       </ActionModal>

//       <ActionModal id="complaintModal" title="Raise Complaint">
//         <FormGroup label="Category" id="complaintCategory" placeholder="e.g., Plumbing, Electrical" required />
//         <FormGroup label="Description" id="complaintDesc" type="textarea" required />
//         <ModalFooter primary="Submit Complaint" />
//       </ActionModal>

//       <ActionModal id="securityLogModal" title="Security Log">
//         <FormGroup label="Incident Title" id="incidentTitle" required />
//         <FormGroup label="Date & Time" id="incidentDate" type="datetime-local" required />
//         <FormGroup label="Details" id="incidentDetails" type="textarea" />
//         <ModalFooter primary="Save Log" />
//       </ActionModal>
//     </section>
//   );
// };

// export default FeaturesQuickActions;

// FeaturesQuickActions.jsx
import React, { useState } from "react";
import "./flip-cards.mobile.css";

import ActionModal from "./common/ActionModal";
import FormGroup from "./common/FormGroup";
import ModalFooter from "./common/ModalFooter";

const QuickActionCard = ({ icon, title, desc, target, btnText }) => (
  <div className="col-12 col-sm-6 col-lg-4">
    <div className="card h-100 shadow-sm">
      <div className="card-body">
        <div className="d-flex align-items-center mb-2">
          <i className={`bi ${icon} text-primary-label fs-3 me-2`} aria-hidden="true" />
          <h5 className="card-title mb-0">{title}</h5>
        </div>
        <p className="card-text text-muted">{desc}</p>
        <button
          className="btn btn-outline-teal"
          data-bs-toggle="modal"
          data-bs-target={target}
          type="button"
          aria-controls={target.replace("#", "")}
          aria-haspopup="dialog"
        >
          {btnText}
        </button>
      </div>
    </div>
  </div>
);

const FeaturesQuickActions = () => {
  const actions = [
    { icon: "bi-calendar-plus", title: "Create Event", desc: "Plan society events, invite residents, manage RSVPs.", id: "createEventModal", btnText: "Create" },
    { icon: "bi-check2-square", title: "Conduct Election", desc: "Set up digital voting, track results securely.", id: "conductElectionModal", btnText: "Setup" },
    { icon: "bi-megaphone", title: "Publish Notice", desc: "Announce updates with read receipts & attachments.", id: "publishNoticeModal", btnText: "Publish" },
    { icon: "bi-pass", title: "Generate Entry Pass", desc: "Visitor pass with QR verification at gate.", id: "entryPassModal", btnText: "Generate" },
    { icon: "bi-exclamation-octagon", title: "Raise Complaint", desc: "Ticketing with SLA, comments, and escalations.", id: "complaintModal", btnText: "Raise" },
    { icon: "bi-shield-shaded", title: "Security Log", desc: "Guard shifts, incident logs, and analytics.", id: "securityLogModal", btnText: "Log" },
  ];

  // Screen-reader friendly flip state (mobile)
  const [flipped, setFlipped] = useState(() => actions.map(() => false));
  const toggleFlip = (i) =>
    setFlipped((prev) => prev.map((f, idx) => (idx === i ? !f : f)));

  const onContainerKeyDown = (e, i) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      toggleFlip(i);
    }
  };

  return (
    <section id="features" className="py-5 bg-light">
      <div className="container">
        <div className="text-center mb-4">
          <h2 className="fw-bold text-primary-label">Do More With Quick Actions</h2>
          <p className="text-muted">Create events, conduct elections, publish notices—instantly.</p>
        </div>

        {/* --- MOBILE (< md): compact 2×N flip grid with colors & micro-interactions --- */}
        <div className="d-md-none">
          <div className="qa-grid-compact" role="list" aria-label="Quick actions">
            {actions.map((a, i) => {
              const target = `#${a.id}`;
              const hintId = `${a.id}-hint`;
              const liveId = `${a.id}-live`;
              const titleId = `${a.id}-title`;
              const colorClass = `qa-${(i % 6) + 1}`;

              return (
                <div key={a.id} role="listitem">
                  <span id={hintId} className="visually-hidden">
                    Press Enter or Space to flip and reveal the action details and button.
                  </span>
                  <span id={liveId} className="visually-hidden" aria-live="polite">
                    {flipped[i] ? "Details shown." : "Details hidden."}
                  </span>

                  {/* OUTER INTERACTIVE CONTAINER: use a non-button to avoid nested <button> */}
                  <div
                    className={`flip-card qa-flip ${flipped[i] ? "is-flipped" : ""} ${colorClass}`}
                    role="button"
                    tabIndex={0}
                    onClick={() => toggleFlip(i)}
                    onKeyDown={(e) => onContainerKeyDown(e, i)}
                    aria-expanded={flipped[i]}
                    aria-describedby={`${hintId} ${liveId}`}
                    aria-roledescription="flip card"
                    aria-label={a.title}
                  >
                    <span className="qa-ripple" aria-hidden="true"></span>

                    <div className="flip-card-inner">
                      {/* FRONT (icon + title + short preview) */}
                      <div className="flip-card-face flip-card-front" aria-hidden={flipped[i]}>
                        <div className="qa-header">
                          <div className="qa-badge icon-wrap icon-animated text-primary-label" aria-hidden="true">
                            <i className={`bi ${a.icon} icon-lg`} />
                          </div>
                          <div className="qa-title" id={titleId}>
                            {a.title}
                          </div>
                        </div>
                        {/* short preview (two lines max) */}
                        <p className="qa-preview text-muted" aria-hidden="true">
                          {a.desc}
                        </p>
                      </div>

                      {/* BACK (desc + CTA) */}
                      <div className="flip-card-face flip-card-back" aria-hidden={!flipped[i]}>
                        <div className="qa-title">{a.title}</div>
                        <p className="qa-desc text-muted">{a.desc}</p>

                        {/* INNER MODAL TRIGGER: real <button> works with Bootstrap data attributes */}
                        <button
                          type="button"
                          className="btn btn-outline-teal btn-sm w-100"
                          data-bs-toggle="modal"
                          data-bs-target={target}
                          aria-controls={a.id}
                          aria-haspopup="dialog"
                          onClick={(e) => {
                            // Prevent flip container click from firing
                            e.stopPropagation();
                          }}
                          onKeyDown={(e) => {
                            // Avoid Space propagating to container
                            if (e.key === " ") e.stopPropagation();
                          }}
                        >
                          {a.btnText}
                        </button>

                        <span className="hint d-block mt-1">Tap to flip back</span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* DESKTOP/TABLET (>= md): Original Bootstrap cards */}
        <div className="row g-4 d-none d-md-flex">
          {actions.map((a) => (
            <QuickActionCard
              key={a.id}
              icon={a.icon}
              title={a.title}
              desc={a.desc}
              target={`#${a.id}`}
              btnText={a.btnText}
            />
          ))}
        </div>
      </div>

      {/* ---- Shared Modals ---- */}
      <ActionModal id="createEventModal" title="Create Event">
        <FormGroup label="Event Title" id="eventTitle" required />
        <FormGroup label="Date & Time" id="eventDate" type="datetime-local" required />
        <FormGroup label="Location" id="eventLocation" required />
        <FormGroup label="Description" id="eventDesc" type="textarea" />
        <ModalFooter primary="Create Event" />
      </ActionModal>

      <ActionModal id="conductElectionModal" title="Conduct Election">
        <FormGroup label="Election Title" id="electionTitle" required />
        <FormGroup label="Start Date" id="electionStart" type="date" required />
        <FormGroup label="End Date" id="electionEnd" type="date" required />
        <FormGroup label="Positions" id="electionPositions" placeholder="e.g., President, Secretary" />
        <ModalFooter primary="Start Election" />
      </ActionModal>

      <ActionModal id="publishNoticeModal" title="Publish Notice">
        <FormGroup label="Subject" id="noticeSubject" required />
        <FormGroup label="Message" id="noticeMessage" type="textarea" required />
        <FormGroup label="Attachment (optional)" id="noticeFile" type="file" />
        <ModalFooter primary="Publish Notice" />
      </ActionModal>

      <ActionModal id="entryPassModal" title="Generate Entry Pass">
        <FormGroup label="Visitor Name" id="visitorName" required />
        <FormGroup label="Resident Flat" id="residentFlat" required />
        <FormGroup label="Visit Date" id="visitDate" type="date" required />
        <ModalFooter primary="Generate QR Pass" />
      </ActionModal>

      <ActionModal id="complaintModal" title="Raise Complaint">
        <FormGroup label="Category" id="complaintCategory" placeholder="e.g., Plumbing, Electrical" required />
        <FormGroup label="Description" id="complaintDesc" type="textarea" required />
        <ModalFooter primary="Submit Complaint" />
      </ActionModal>

      <ActionModal id="securityLogModal" title="Security Log">
        <FormGroup label="Incident Title" id="incidentTitle" required />
        <FormGroup label="Date & Time" id="incidentDate" type="datetime-local" required />
        <FormGroup label="Details" id="incidentDetails" type="textarea" />
        <ModalFooter primary="Save Log" />
      </ActionModal>
    </section>
  );
};

export default FeaturesQuickActions;
